module.exports = __webpack_public_path__ + "static/img/mango_th.35a4091.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/mango_th.png
// module id = BtE4
// module chunks = 0